import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Createorganization from "./CreateOrganization"; 
import organizationLogo from './assets/business-os-logo.png';
import './css/dashboard.css';


const AddorganizationHomePage = () => {
  const [activeTab, setActiveTab] = useState("Create organization"); // State to track the active tab
  const navigate = useNavigate();

  // Render component based on the active tab
  const renderComponent = () => {
    switch (activeTab) {
      case "Create organization":
        return <Createorganization />;
      default:
        return null;
    }
  };

  return (
    <div className="organization-dashboard">
      <div className="organization-dashboard-sidebar">
        <div style={{ display: 'flex', flexDirection: 'column', margin: '4vh auto', paddingLeft: '20px' }}>
          <img src={organizationLogo} alt='organization Logo' width='100' height='100' />
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              marginTop: "4vh",
              gap: "1vh",
              marginLeft: '30px',
            }}
          >
            <p
              style={{ fontSize: '14px', fontWeight: '400', lineHeight: '20px',  color: activeTab==='Create organization'?'#ffffff':'#000000', cursor: "pointer" }}
              onClick={() => setActiveTab("Create organization")}
            >
              Create organization
            </p>
          </div>
        </div>
      </div>
      <div className="main-content organization-dashboard-main">
        {renderComponent()}
      </div>
    </div>
  );
};

export default AddorganizationHomePage;
